/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Capacity_KgInputs */

const vi_vehicle_capacity_kg = /** @type {(inputs: Vehicle_Capacity_KgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải trọng (kg)`)
};

/**

* @param {Vehicle_Capacity_KgInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_capacity_kg = /** @type {((inputs?: Vehicle_Capacity_KgInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Capacity_KgInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_capacity_kg(inputs)
});